import React, { useState, useEffect } from "react"
import { useTheme } from '~/contexts/ThemeContext'
import { usePdp } from '~/contexts/PdpContext'
import useLastViewsHook from '~/utils/last-views'

import LastViewed from '~/components/pdp/last-viewed'
import TilePage from '~/components/tile/tile-page'

import { aria_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/pdp/cross_sell.module.scss"
import * as swtch from "~/styles/shared/undrtoggle.module.scss"

const CrossSell = () => {
  const { gender } = useTheme()
  const { product, recProds } = usePdp()

  const product_id = product.mid

  const { getLasts } = useLastViewsHook()

  const [show, setShow] = useState('recs')
  const [lasts, setLasts] = useState(false)
  const [isTest, setIsTest] = useState(false)

  const handleSwitch = (type) => {
    setShow('lasts')
    window._conv_q = window._conv_q || []
    window._conv_q.push(["triggerConversion", "100473637"])
  }

  useEffect(() => {
    const check_lasts = getLasts({product_id: product_id})
    setLasts(check_lasts)

    const check_test = sessionStorage.getItem('lastv') === 'true'
    const has_lasts = check_lasts && check_lasts.length > 0
    setIsTest(has_lasts && check_test)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (
    <>
      {(!recProds || (isTest && !lasts)) ? (
        <></>
      ) : (
        <div className={styles.cross} role="complementary" crx=''>
          {(isTest && (lasts.length > 0 || recProds.length > 0)) ? (
            <div className={[styles.title, styles.swtch, swtch.swtch_btns].join(' ')}>
              {recProds.length > 0 && (
                <button 
                  type="button"
                  className={[aria_btn, swtch.swtch_btn].join(' ')}
                  onClick={(e)=> setShow('recs')}
                  aria-current={show === 'recs' ? 'true' : 'false'}
                >
                  Recommended
                </button>
              )}
              {lasts.length > 0 && (
                <button 
                  type="button"
                  className={[aria_btn, swtch.swtch_btn].join(' ')}
                  onClick={(e)=> handleSwitch('lasts')}
                  aria-current={(!recProds.length || show === 'lasts') ? 'true' : 'false'}
                >
                  Last Viewed
                </button>
              )}
            </div>
          ) : (
            <div className={styles.title}>
              Recommended
            </div>
          )}
          {(recProds && show === 'recs') && (
            <div className={styles.tiles}>
              {recProds.map( (prod, index) =>
                <TilePage 
                  key={prod.handle} 
                  product={prod} 
                  tile_ind={index} 
                  page_type={'pdp recommendation'} 
                />
              )}
            </div>
          )}
          {(isTest && show === 'lasts') && (
            <LastViewed product_id={product_id} />
          )}
        </div>
      )}
    </>
  )
}

export default CrossSell



